import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { ControlsModule } from "src/app/controls/controls.module";
import { SharedModule } from "../../shared/shared.module";
import { LearnsetsListComponent } from "src/app/shared/learnsets-list/learnsets-list.component";
import { SmartRepetitionComponent } from "./smart-repetition.component";
import { SmartRepetitionListComponent } from "../smart-repetition-list/smart-repetition-list.component";
import { TablerIconComponent } from "angular-tabler-icons";
import { CoreModule } from "src/app/core/core.module";

@NgModule({
  declarations: [
    SmartRepetitionComponent,
    SmartRepetitionListComponent
  ],
  imports: [
    CommonModule,
    ControlsModule,
    SharedModule,
    LearnsetsListComponent,
    TablerIconComponent,
    CoreModule
  ],
  exports: [
    SmartRepetitionComponent,
    SmartRepetitionListComponent
  ]
})
export class SmartRepetitionModule { }